import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=db7980e2&scoped=true"
var script = {}
import style0 from "./Divider.vue?vue&type=style&index=0&id=db7980e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7980e2",
  null
  
)

export default component.exports